export const firebaseConfig = {
  apiKey: 'AIzaSyAutXM6lfkEHil6RpML8jMVbPd_Cb9ZvA4',
  authDomain: 'enhirely-app.firebaseapp.com',
  databaseURL: 'https://enhirely-app-default-rtdb.firebaseio.com',
  projectId: 'enhirely-app',
  storageBucket: 'enhirely-app.appspot.com',
  messagingSenderId: '464937870463',
  appId: '1:464937870463:web:29fb0481fb18b413aa4b4a',
  measurementId: 'G-ZX4NH9JEQZ',
};
